var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { ListItem, List, ListItemText } from '@mui/material';
import { EGamePhase, EGameStatus, EPlayerGameStateKeysPrivate, EPlayerGameStateKeysPublic, ERoleTypes, getGameStatusString, getPlayerGameStateString, getRoleString, } from '../../../types';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { selectMatchState, selectShowRoles, setMatchState, toggleShowRoles } from '../../../store/match';
import { Delimiter } from '../../atoms/Delimiter';
import { VotesList } from '../VotesList';
import { ModalNew } from '../../atoms/Modal/Modal';
import { PlayerActions } from '../PlayerActions';
import * as api from '../../../api/matches';
import { confirmPlayerPass } from '../../../api';
import { ModalWrapperNew } from '../../atoms/ModalWrapper/ModalWrapper';
import { MatchEnd } from '../../../pages/MatchEnd';
import { useAlerts } from '../../molecules/Alerts';
import { getMafiaErrors } from '../../../utils';
import ReturnIco from '../../../../public/img/Return.svg';
import VotesIcon from '../../../../public/img/VotesIcon.svg';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
const PlayersContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  min-width: 780px;
  min-height: 720px;
`;
const GameDesk = styled.div `
  position: relative;
  width: 838px;
  height: 100%;
  display: flex;
  //margin: 0 auto;
`;
const DeskWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  touch-action: none;
`;
const DeskHeader = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  width: calc(100% - 120px);
  z-index: 1000;
`;
const DeskFooter = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;
const GameInfoContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  max-height: calc(100vh - 120px);
  min-width: 300px;
  overflow-y: auto;
`;
const ModalWrapper = styled(ModalWrapperNew) `
  align-items: flex-start;
  padding: 30px 30px 0;
  min-width: 527px;
`;
const ModalVotesWrapper = styled(ModalWrapperNew) `
  align-items: flex-start;
`;
const listStyles = {
    width: '100%',
    borderRadius: '12px',
    boxShadow: '0px 6px 18px 0px rgba(0, 0, 0, 0.39)',
};
const listContainerStyles = {
    width: '158px',
    height: 'fit-content',
    position: 'absolute',
    right: '60px',
};
const VotesButton = styled.div `
  display: flex;
  align-items: center;
`;
export function MatchDesk({ players, onClickPlayerAction, gameButtonState, setCurrentPlayerId, addOnComponent, }) {
    var _a, _b, _c;
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const showRoles = useAppSelector(selectShowRoles);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [viewVotes, setViewVotes] = useState(false);
    const [viewFouls, setViewFouls] = useState(false);
    const [viewEndGame, setViewEndGame] = useState(false);
    const [isCancelLoading, setIsCancelLoading] = useState(false);
    const candidates = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).candidates || [], [matchState]);
    const shooters = useMemo(() => { var _a, _b; return ((_b = (_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.shootout) === null || _b === void 0 ? void 0 : _b.players) || []; }, [matchState]);
    const votes = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).votes || [], [matchState]);
    const gameStatus = useMemo(() => matchState === null || matchState === void 0 ? void 0 : matchState.gameStatus, [matchState]);
    const { setAlerts } = useAlerts();
    const getPlayer = (playerId) => matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
    const onPlayerClickInner = (playerId) => __awaiter(this, void 0, void 0, function* () {
        if (playerId === (selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id)) {
            setSelectedPlayer(null);
        }
        if (selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => (player === null || player === void 0 ? void 0 : player.id) === playerId)) {
            setSelectedPlayers(selectedPlayers.filter((player) => player.id !== playerId));
            yield (onClickPlayerAction === null || onClickPlayerAction === void 0 ? void 0 : onClickPlayerAction(''));
            return;
        }
        setSelectedPlayer(getPlayer(playerId) || null);
        const player = getPlayer(playerId);
        if (player && selectedPlayers && gameStatus === EGameStatus.GAME_ROLE_SETTING_NIGHT) {
            setSelectedPlayers([...selectedPlayers, player]);
        }
        else if (player && selectedPlayers && gameStatus !== EGameStatus.GAME_ROLE_SETTING_NIGHT) {
            setSelectedPlayers([player]);
        }
        yield (onClickPlayerAction === null || onClickPlayerAction === void 0 ? void 0 : onClickPlayerAction(playerId));
    });
    const onVotesOpen = () => {
        setViewVotes(true);
    };
    const onVotesClose = () => {
        setViewVotes(false);
    };
    const onFoulsClick = () => {
        setViewFouls(!viewFouls);
    };
    const onEndPageClick = () => {
        setViewEndGame(!viewEndGame);
    };
    const onChangeViewModeClick = () => {
        dispatch(toggleShowRoles());
    };
    const onChangeRole = () => {
        setSelectedPlayer(null);
        setSelectedPlayers([]);
    };
    const onPassButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        var _d, _e;
        const currentVoteId = ((_d = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _d === void 0 ? void 0 : _d.voteId) || '';
        const currentPlayer = (_e = matchState === null || matchState === void 0 ? void 0 : matchState.players) === null || _e === void 0 ? void 0 : _e.find((p) => { var _a; return p.id === ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer); });
        if (currentPlayer === undefined) {
            return;
        }
        try {
            const result = yield confirmPlayerPass(currentVoteId, currentPlayer.id);
            // console.log('MatchDesk onStartGameClick', result)
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
            console.error('MatchDesk onStartGameClick error', err.response);
        }
    });
    const cancelLastAction = () => __awaiter(this, void 0, void 0, function* () {
        if (!(matchState === null || matchState === void 0 ? void 0 : matchState.id))
            return;
        setIsCancelLoading(true);
        try {
            const result = yield api.cancelAction(matchState === null || matchState === void 0 ? void 0 : matchState.id);
            dispatch(setMatchState(result));
            setIsCancelLoading(false);
        }
        catch (e) {
            setIsCancelLoading(false);
            console.log(getMafiaErrors(e));
            setAlerts(getMafiaErrors(e));
            // console.error('Match cancelAction', (e as any).response)
        }
    });
    const getMatchState = () => __awaiter(this, void 0, void 0, function* () {
        if (!(matchState === null || matchState === void 0 ? void 0 : matchState.id))
            return;
        try {
            const result = yield api.getMatchState(matchState === null || matchState === void 0 ? void 0 : matchState.id);
            // console.log('Match getMatchState', result)
            dispatch(setMatchState(result));
            // dividePlayers(result.players)
        }
        catch (e) {
            console.error('Match getMatchState', e.response);
        }
    });
    useEffect(() => {
        var _a;
        setCurrentPlayerId(((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer) || null);
    }, [matchState]);
    const isSuggested = (playerId) => candidates.find((c) => c.id === playerId);
    const roundStarter = (playerId) => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.roundStarter) === playerId; };
    const isCurrentPlayer = (playerId) => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentPlayer) === playerId; };
    const votesCount = (playerId) => {
        const result = votes.find((c) => c.playerId === playerId);
        return (result === null || result === void 0 ? void 0 : result.votes) || 0;
    };
    const votingProcess = gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
        gameStatus === EGameStatus.PLAYER_VOTING ||
        gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE;
    return (_jsxs(Container, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: [_jsxs(DeskWrapper, { children: [_jsx(DeskHeader, { children: _jsx(Button, Object.assign({ variant: "contained", onClick: () => onEndPageClick() }, { children: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0438\u0433\u0440\u0443" })) }), _jsxs(GameDesk, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: [_jsx(PlayersContainer, { children: _jsx(Paper, { children: _jsx(TableContainer, Object.assign({ sx: { maxWidth: 718, maxHeight: 'calc(100vh - 120px)' } }, { children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head" }, { children: "\u0418\u043C\u044F" })), _jsx(TableCell, Object.assign({ variant: "head" }, { children: "\u0420\u043E\u043B\u044C" })), _jsx(TableCell, Object.assign({ variant: "head" }, { children: "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435" }))] }) }), _jsx(TableBody, { children: players.map((p) => {
                                                        const selected = (gameStatus === EGameStatus.ROLE_PERFORM_NIGHT_ACTION &&
                                                            (p.role === (matchState === null || matchState === void 0 ? void 0 : matchState.state.currentRole) ||
                                                                ((matchState === null || matchState === void 0 ? void 0 : matchState.state.currentRole) === 'MAFIA' && p.role === 'DON'))) ||
                                                            (selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => player.id === p.id)) ||
                                                            ((gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE ||
                                                                gameStatus === EGameStatus.SELECT_DIRECTION_OF_INTRODUCE) &&
                                                                !!isSuggested(p.id)) ||
                                                            isCurrentPlayer(p.id);
                                                        const suggested = 
                                                        // eslint-disable-next-line no-nested-ternary
                                                        gameStatus === EGameStatus.PLAYER_VOTING || gameStatus === EGameStatus.PLAYER_VOTE_STATE
                                                            ? selected && !isCurrentPlayer(p.id)
                                                            : gameStatus === EGameStatus.ROLE_PERFORM_NIGHT_ACTION
                                                                ? selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => player.id === p.id)
                                                                : !!isSuggested(p.id) && (selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => player.id === p.id));
                                                        const disable = (roundStarter(p.id) && !selected) ||
                                                            // eslint-disable-next-line no-nested-ternary
                                                            (gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE ||
                                                                gameStatus === EGameStatus.SELECT_DIRECTION_OF_INTRODUCE ||
                                                                gameStatus === EGameStatus.PLAYER_VOTING ||
                                                                gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                                                                gameStatus === EGameStatus.PLAYER_INTRODUCING ||
                                                                gameStatus === EGameStatus.INTRODUCE_YOURSELF_STATE ||
                                                                gameStatus === EGameStatus.ROLE_PERFORM_NIGHT_ACTION
                                                                ? !suggested && !selected
                                                                : candidates.length
                                                                    ? !suggested
                                                                    : false);
                                                        const playerState = {
                                                            selected,
                                                            suggested,
                                                            disable: gameStatus === EGameStatus.GAME_ROLE_SETTING_NIGHT
                                                                ? p.role !== ERoleTypes.CIVILIAN && !(selectedPlayers === null || selectedPlayers === void 0 ? void 0 : selectedPlayers.some((player) => player.id === p.id))
                                                                : disable,
                                                            gameState: selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.state,
                                                            votesCount: votesCount(p.id),
                                                        };
                                                        const stateStrings = getPlayerGameStateString(p.state || null);
                                                        const publicStatus = Object.values(EPlayerGameStateKeysPublic).map((key) => stateStrings[key] ? stateStrings[key] : null);
                                                        if (playerState.votesCount > 0) {
                                                            publicStatus[3] = `Голосов ${playerState.votesCount}`;
                                                        }
                                                        const privateStatus = Object.values(EPlayerGameStateKeysPrivate).map((key) => stateStrings[key] ? stateStrings[key] : null);
                                                        const currentStatus = showRoles ? [...publicStatus, ...privateStatus] : publicStatus;
                                                        const voteTarget = p === selectedPlayer && votingProcess;
                                                        return (_jsxs(TableRow, Object.assign({ id: p.id, selected: selected, onClick: () => onPlayerClickInner(p.id), className: voteTarget ? 'voteTarget' : '' }, { children: [_jsx(TableCell, Object.assign({ variant: "body" }, { children: p.player.gameName })), _jsx(TableCell, Object.assign({ variant: "body", className: "role" }, { children: showRoles && getRoleString(p.role) })), _jsx(TableCell, Object.assign({ variant: "body" }, { children: showRoles && currentStatus.filter((el) => el).join(', ') }))] }), p.id));
                                                    }) })] }) })) }) }), _jsxs(GameInfoContainer, Object.assign({ day: (matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY }, { children: [_jsxs(Typography, Object.assign({ variant: "h2" }, { children: [(matchState === null || matchState === void 0 ? void 0 : matchState.gamePhase) === EGamePhase.DAY ? 'День' : 'Ночь', " \u2116", (matchState === null || matchState === void 0 ? void 0 : matchState.dayNumber) || 1] })), _jsx(Delimiter, { top: "10px" }), _jsx(Typography, Object.assign({ sx: { color: '#899295' }, variant: "subtitle1" }, { children: getGameStatusString(gameStatus) })), _jsx(Delimiter, { top: "9px" }), (gameStatus === EGameStatus.SELECT_WHO_START_VOTING ||
                                        gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                                        gameStatus === EGameStatus.PLAYER_VOTING ||
                                        gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE) && (_jsxs(_Fragment, { children: [_jsxs(VotesButton, Object.assign({ onClick: onVotesOpen }, { children: [_jsx("img", { src: VotesIcon, alt: "VotesIcon" }), _jsx(Typography, Object.assign({ sx: { marginLeft: '10px', color: '#1976D2', fontWeight: '600' }, variant: "body1" }, { children: "\u0413\u043E\u043B\u043E\u0441\u0430" }))] })), _jsx(Delimiter, { top: "12px" })] })), addOnComponent === null || addOnComponent === void 0 ? void 0 : addOnComponent({
                                        player: selectedPlayer,
                                        onClose: onChangeRole,
                                        onFouls: onFoulsClick,
                                        players: selectedPlayers,
                                    })] }))] })), _jsx(DeskFooter, { children: _jsx(Paper, Object.assign({ sx: listContainerStyles }, { children: _jsxs(List, Object.assign({ sx: listStyles }, { children: [_jsx(ListItem, Object.assign({ onClick: onFoulsClick }, { children: _jsx(ListItemText, { primary: "\u0424\u043E\u043B\u044B" }) })), _jsxs(ListItem, Object.assign({ onClick: cancelLastAction, className: "cancel" }, { children: [_jsx("img", { src: ReturnIco, alt: "return" }), _jsx(ListItemText, { primary: "\u043E\u0442\u043C\u0435\u043D\u0430" })] })), (gameStatus === EGameStatus.SELECT_WHO_START_VOTING ||
                                        gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                                        gameStatus === EGameStatus.PLAYER_VOTING ||
                                        gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE) && (_jsx(ListItem, Object.assign({ onClick: onPassButtonClick }, { children: _jsx(ListItemText, { primary: "\u043F\u0430\u0441" }) }))), _jsx(ListItem, Object.assign({ onClick: onChangeViewModeClick, className: showRoles ? 'status' : '' }, { children: _jsx(ListItemText, { primary: "\u0441\u0442\u0430\u0442\u0443\u0441" }) })), (gameStatus === EGameStatus.SELECT_WHO_START_VOTING ||
                                        gameStatus === EGameStatus.PLAYER_VOTE_STATE ||
                                        gameStatus === EGameStatus.PLAYER_VOTING ||
                                        gameStatus === EGameStatus.SELECT_DIRECTION_OF_VOTE) && (_jsx(ListItem, Object.assign({ onClick: onVotesOpen }, { children: _jsx(ListItemText, { primary: "\u0413\u043E\u043B\u043E\u0441\u0430" }) }))), (gameButtonState === null || gameButtonState === void 0 ? void 0 : gameButtonState.visible) && (_jsxs(_Fragment, { children: [_jsx(ListItem, Object.assign({ onClick: gameButtonState.onClick, className: `gameButtonState ${gameButtonState.disabled ? 'disabled' : ''} ${gameButtonState.addOnText ? '' : 'round'}` }, { children: _jsx(ListItemText, { primary: gameButtonState.text }) })), gameButtonState.addOnText && (_jsx(ListItem, Object.assign({ className: "timer" }, { children: _jsx(ListItemText, { secondary: `${gameButtonState.addOnText.minutes}:${gameButtonState.addOnText.seconds}` }) })))] }))] })) })) })] }), viewVotes && (_jsx(ModalNew, Object.assign({ close: true, onClose: onVotesClose }, { children: _jsx(ModalVotesWrapper, { children: _jsx(VotesList, { players: (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [], votes: ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.votes) || [], previousVote: ((_b = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _b === void 0 ? void 0 : _b.previousVote) || null, voteItems: ((_c = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _c === void 0 ? void 0 : _c.voteItems) || [], dayNumber: (matchState === null || matchState === void 0 ? void 0 : matchState.dayNumber) || 1 }) }) }))), viewFouls && (_jsx(ModalNew, Object.assign({ close: true, onClose: onFoulsClick }, { children: _jsx(ModalWrapper, { children: _jsx(PlayerActions, { players: (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [], matchId: (matchState === null || matchState === void 0 ? void 0 : matchState.id) || '', reload: () => getMatchState() }) }) }))), viewEndGame && (_jsx(ModalNew, Object.assign({ close: true, onClose: onEndPageClick }, { children: _jsx(MatchEnd, {}) })))] })));
}
